import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganisationsComponent } from './organisations.component';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { OrganisationDialogComponent } from './organisation-dialog.component';
import { OrganisationService } from './organisation.service';
import { ModelDialogComponent } from './models/model-dialog.component';
import { UIComponentsModule } from '../ui-components/ui-components.module';
import { ModelService } from './models/model-service';
import { OrganisationUsersComponent } from './users/organisation-users.component';
import { TagGroupDialogComponent } from './tags/tag-group-dialog.component';
import { TagsService } from './tags/tags-service';
import { ProjectDialogComponent } from './projects/project-dialog.component';
import { UserAccessComponent } from './users/user-access.component';
import { OrganisationStatisticsComponent } from './statistics/organisation-statistics.component';
import { OrganisationUserDialogComponent } from './users/organisation-user-dialog.component';
import { ModelTableComponent } from './models/model-table.component';
import { ProjectTableComponent } from './projects/project-table.component';
import { RestoreModelDialogComponent } from './models/restore-model-dialog.component';
import { TodoListComponent } from './todo-list/todo-list.component';
import { EmissionFactorsComponent } from './carbon/emission-factors.component';
import { EmissionFactorDialogComponent } from './carbon/emission-factor-dialog.component';
import { ModelComponentsModule } from '../model-components/model-components.module';
import { InsightsModule } from '../insights/insights.module';
import { TableComponent } from '../ui-components/table/table-component';
import { ChartsModule } from '../charts/charts.module';

@NgModule({
  declarations: [
    OrganisationsComponent,
    OrganisationDialogComponent,
    ModelDialogComponent,
    ProjectDialogComponent,
    OrganisationUsersComponent,
    TagGroupDialogComponent,
    UserAccessComponent,
    OrganisationStatisticsComponent,
    OrganisationUserDialogComponent,
    ModelTableComponent,
    ProjectTableComponent,
    RestoreModelDialogComponent,
    TodoListComponent,
    EmissionFactorsComponent,
    EmissionFactorDialogComponent
  ],
  exports: [
    OrganisationsComponent,
    OrganisationUsersComponent,
    OrganisationStatisticsComponent,
    ModelTableComponent,
    ProjectTableComponent,
    TodoListComponent,
    EmissionFactorsComponent,
    EmissionFactorDialogComponent
  ],
  imports: [
    MaterialModule,
    FormsModule,
    CommonModule,
    UIComponentsModule,
    ModelComponentsModule,
    InsightsModule,
    TableComponent,
    ChartsModule
  ],
  providers: [
    OrganisationService,
    ModelService,
    TagsService
  ]
})
export class OrganisationModule { }
